/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CleanUpRequestBuilderNavigationMetadata, CleanUpRequestBuilderRequestsMetadata, type CleanUpRequestBuilder } from './cleanUp/index.js';
// @ts-ignore
import { ScanRequestBuilderNavigationMetadata, ScanRequestBuilderRequestsMetadata, type ScanRequestBuilder } from './scan/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/housekeeping
 */
export interface HousekeepingRequestBuilder extends BaseRequestBuilder<HousekeepingRequestBuilder> {
    /**
     * The cleanUp property
     */
    get cleanUp(): CleanUpRequestBuilder;
    /**
     * The scan property
     */
    get scan(): ScanRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const HousekeepingRequestBuilderUriTemplate = "{+baseurl}/api/images/housekeeping";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const HousekeepingRequestBuilderNavigationMetadata: Record<Exclude<keyof HousekeepingRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    cleanUp: {
        requestsMetadata: CleanUpRequestBuilderRequestsMetadata,
        navigationMetadata: CleanUpRequestBuilderNavigationMetadata,
    },
    scan: {
        requestsMetadata: ScanRequestBuilderRequestsMetadata,
        navigationMetadata: ScanRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
